import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// where each role lands by default
export const roleHome = (role) => {
  if (role === "customer") return "/quotes";
  if (role === "user_admin") return "/users";   // 2026-06 · only manages users
  return "/";
};

export function ProtectedRoute({ children, adminOnly = false, roles = null }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-sm text-muted-foreground font-body" data-testid="auth-loading">
        Loading...
      </div>
    );
  }
  // 2026-06 · Keep the deep link (e.g. /procurement-request/:token) so the user
  // lands back on it after logging in instead of on their home page.
  if (user === false) {
    const next = `${location.pathname}${location.search}`;
    const to = next && next !== "/" ? `/login?next=${encodeURIComponent(next)}` : "/login";
    return <Navigate to={to} replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to={roleHome(user.role)} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
